export const feedbackConstants = {
  SUBMIT_REQUEST: 'FEEDBACK_SUBMIT_REQUEST',
  SUBMIT_SUCCESS: 'FEEDBACK_SUBMIT_SUCCESS',
  SUBMIT_FAILURE: 'FEEDBACK_SUBMIT_FAILURE'
};
